const safeSum = (property, collection) => collection.reduce((sum, item) => sum + (item[property] || 0), 0);

export default safeSum;
